import React from "react";
import { Typography, Grid, Button, Box } from "@mui/material";
import "../Header/header.css";

import Navbar from "../navbar";
import Footer from "../Footer";

const Donate = () => {
  return (
    <>
      <Navbar />
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "50px 0", background: "#2F70FE", textAlign: "center" }}
        >
          <Typography className="text">Donate Now</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ textAlign: "center", padding: "50px 0" }}
        >
          <Typography className="text7">
            The Messenger of Allah ﷺ said:
          </Typography>
          <Typography className="text7">
            “The believer’s shade on the Day of Resurrection will be his
            charity.”
          </Typography>
          <Typography className="text7">
            <b>Hadith (Al-Tirmidhi)</b>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ textAlign: "center", padding: "50px 0" }}
        >
          <Typography className="text8">
            <b>SUPPORT YOUR MOSQUE</b>
          </Typography>
          <Typography className="text7">
            Your generous donations keep your mosque open and ready to serve our
            community.
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          padding: "50px 0",
        }}
      >
        <Grid item xs={2} md={2}></Grid>
        <Grid item xs={8} md={8}>
          <Box
            sx={{
              textAlign: "center",
              border: "1px solid black",
              padding: "50px 0",
            }}
          >
            <Typography sx={{ paddingTop: "10px" }} className="text8">
              <b>Bank Transfer</b>
            </Typography>
            {/* <Typography sx={{ paddingTop: "10px" }} className="text7">
              <b>Account Name:</b>
            </Typography>
            <Typography className="text7">
              
            </Typography> */}
            <Typography sx={{ paddingTop: "10px" }} className="text7">
              <b>Bank Name:</b>
            </Typography>
            <Typography className="text7">Santander Bank
</Typography>
            <Typography sx={{ paddingTop: "10px" }} className="text7">
              <b>Account No:</b>
            </Typography>
            <Typography className="text7">59100020961</Typography>
            <Typography sx={{ paddingTop: "10px" }} className="text7">
              <b>Routing number:</b>
            </Typography>
            <Typography className="text7">011075150</Typography>
            {/* <Typography sx={{ paddingTop: "10px" }} className="text7">
              <b>IBAN:</b>
            </Typography>
            <Typography className="text7">xyz</Typography>
            <Typography sx={{ paddingTop: "10px" }} className="text7">
              <b>Branch Identifier Code:</b>
            </Typography>
            <Typography className="text7">xyz</Typography> */}
          </Box>
        </Grid>
        <Grid item xs={2} md={2}></Grid>
      </Grid>
      <Footer />
    </>
  );
};
export default Donate;
